window.addEventListener("DOMContentLoaded", (event: Event) =>
{
    loadBodyMenu();
});

function loadBodyMenu(): void
{
    const bodyBlock = document.querySelector(".js-headermenu-target");

    if (bodyBlock &&
        // Only if not yet loaded.
        bodyBlock.childNodes.length <= 0)
    {
        const bodyMenuList = document.createElement("ul");
        bodyMenuList.classList.add("c-bodymenu", "nolist", "show-mobile");

        document.querySelectorAll(".c-headermenu__content .c-headermenu__item").forEach((item) =>
        {
            const clonedItem = item.cloneNode(true) as HTMLLIElement;

            // Delete submenu from cloned item.
            const categoryWrapper = clonedItem.querySelector(".c-headermenu__category-wrapper");
            if (categoryWrapper)
                categoryWrapper.remove();

            const imageHolder = document.createElement("div");
            imageHolder.classList.add("c-headermenu__image-holder", "br-round");

            // Get photo URL and add img element for it.
            const photoUrl = clonedItem.dataset.mobilephotourl;

            if (photoUrl)
            {
                const img = document.createElement("img");
                img.src = photoUrl;

                img.height = 216;
                img.width = 216;

                const textSpan = clonedItem.querySelector("span");
                if (textSpan && textSpan.textContent)
                    img.alt = textSpan.textContent.trim();
                else
                    img.alt = "";

                imageHolder.appendChild(img);

                // Strip data-attribute.
                delete clonedItem.dataset.mobilephotourl;
            }

            // Add img holder before other elements.
            clonedItem.insertBefore(imageHolder, clonedItem.firstChild);

            const existingAnchor = clonedItem.querySelector("a");

            if (existingAnchor)
                existingAnchor.insertBefore(imageHolder, existingAnchor.firstChild);
            else
                clonedItem.insertBefore(imageHolder, clonedItem.firstChild);

            bodyMenuList.appendChild(clonedItem);
        });

        bodyBlock.appendChild(bodyMenuList);
    }
}
